module.exports = __webpack_public_path__ + "img/9791195282807.2655d6d8.jpg";